import React, { useEffect, useState } from 'react';
import client from './contentfulClient';
import { Link } from 'react-router-dom';

const PostProduction = () => {
  const [allProjects, setAllProjects] = useState([]); // all fetched projects
  const [visibleCount, setVisibleCount] = useState(6); // how many are currently visible

  useEffect(() => {
    client
      .getEntries({ content_type: 'postProduction' }) // replace with your actual content type ID
      .then((res) => {
        setAllProjects(res.items);
      })
      .catch(console.error);
  }, []);

  const handleLoadMore = () => {
    setVisibleCount((prevCount) => prevCount + 6);
  };

  const visibleProjects = allProjects.slice(0, visibleCount);
  const hasMore = visibleCount < allProjects.length;

  return (
    <section className="post-production-wrapper">
      <div className="container">
        <h2 className="mb-4"><b>Post Production</b></h2>
        <div className="row">
          {visibleProjects.map((item) => {
            const { title, description, thumbnail } = item.fields;
            const imageUrl = thumbnail?.fields?.file?.url;

            return (
              <div className="col-md-4" key={item.sys.id}>
               <Link to={`/post-production/${item.sys.id}`}>
  <div className="post-pruduction">
    <img
      src={imageUrl ? `https:${imageUrl}` : 'assets/img/placeholder.png'}
      alt={title}
    />
    <div className="overlay">
      <div className="text">
        <h3>{title}</h3>
        
      </div>
    </div>
  </div>
</Link>

              </div>
            );
          })}
        </div>
        {hasMore && (
          <div className="d-flex justify-content-end mt-4">
            <a href="#" onClick={(e) => { e.preventDefault(); handleLoadMore(); }}>Load More</a>
          </div>
        )}
      </div>
    </section>
  );
};

export default PostProduction;
